import MainAddToCartButton from '@/components/CartActions/MainAddToCartButton.vue';
import { mountCoreVueApp } from '@/entrypoints/helpers/core-vue-app';
import GlobalKeyDownDirective from '@/shared/directives/globalKeyDown';

export const initCartActions = async (mountId) => {
  if (!document.getElementById(mountId)) {
    return;
  }

  await mountCoreVueApp(
    MainAddToCartButton,
    `#${mountId}`,
    {},
    (app) => {
      app.directive('global-keydown', GlobalKeyDownDirective);
    },
    { noClients: true }
  );
};
